
import { Injectable } from "@angular/core";
import { SafeFileSystem } from "../services/safeFileSystem.service";
import { CoreLogService } from "../services/log.service";
import { Client } from "../services/com/comEnvironmentClient";

/** Logging Injector, um zirkelbezug zwischen SafeFileSystem und CoreLogService aufzulösen */

// CoreLogInjector must inject as first time in app.component.ts, to set SafeFileSystem to CoreLogService (else it create a circular dependency)
@Injectable({
  providedIn: "root" // damit ist kein Import in app.module.ts notwendig
})
export class CoreLogInjector {
  constructor(private _coreLogService: CoreLogService, private _safeFileSystem: SafeFileSystem) {
  }

  /** Ititialisiert den Log mit dem SafeFileSystem um den Log in eine Datei umleiten zu können.
   * @param client Aktuelle Client (benötigt, da der browser kein FileSystem hat) (als Parameter um keinen Zirkelbezug mit CoreComService zu erzeugen)
   */
  public init(client: Client) {
    this._coreLogService.setSafeFileSystem(this._safeFileSystem, client);
  }
}
